var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGirls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 183,
    viewBox: "0 0 200 183",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D5746CAF-CA2C-4F39-A312-F0269A777B29") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.497 5.569a10.003 10.003 0 0 0-10 10v41.288a10.003 10.003 0 0 0 10 10h56.86L151.5 78V15.569a10.001 10.001 0 0 0-10-10H83.497z",
    fill: "#738C7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.503 0a10.003 10.003 0 0 1 10 10v41.288a10.003 10.003 0 0 1-10 10h-56.86L48.5 72.431V10a10.001 10.001 0 0 1 10-10h58.003z",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(103 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 57c0-3.183-1.264-6.235-3.515-8.485A11.996 11.996 0 0 0 64 45H33a11.996 11.996 0 0 0-8.485 3.515A11.996 11.996 0 0 0 21 57v43h55V57z",
    fill: "#FFD89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 100H21V75.922c7.168-.786 8-7.396 8-15.422 0-5.581-.402-10.476-3.057-13.206A12.007 12.007 0 0 1 33 45h31c2.551 0 5.019.813 7.057 2.294C68.402 50.024 68 54.919 68 60.5c0 8.026.832 14.636 8 15.422V100z",
    fill: "#CC9543"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD89D",
    cx: 48.5,
    cy: 30,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 31.75h-.002C11.64 31.75 0 20.11 0 5.752V4.75l2.361 2.861A30.65 30.65 0 0 0 25.999 18.75H26v13zM71 31.75h.002C85.36 31.75 97 20.11 97 5.752V4.75l-2.361 2.861A30.65 30.65 0 0 1 71.001 18.75H71v13z",
    fill: "#EC761F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 34v-1.5a2.5 2.5 0 1 1 5 0V34M36 34v-1.5a2.5 2.5 0 1 1 5 0V34",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 41h-9a4 4 0 0 0 4 4h1a4 4 0 0 0 4-4z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 35.5A1.503 1.503 0 0 1 31 37h-3.5a1.503 1.503 0 0 1-1.5-1.5V20A20 20 0 0 1 46 0h5a20 20 0 0 1 20 20v15.5a1.503 1.503 0 0 1-1.5 1.5H66a1.503 1.503 0 0 1-1.5-1.5v-4.936A6.564 6.564 0 0 0 57.936 24h-.002a6.435 6.435 0 0 0-6.434 6.434V36.5A1.5 1.5 0 0 1 50 38h-3a1.5 1.5 0 0 1-1.5-1.5v-5.936A6.564 6.564 0 0 0 38.936 24h-.002a6.435 6.435 0 0 0-6.434 6.434V35.5z",
    fill: "#8E8E4C"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5 57c0-3.183-1.264-6.235-3.515-8.485A11.996 11.996 0 0 0 64.5 45h-31a11.996 11.996 0 0 0-8.485 3.515A11.996 11.996 0 0 0 21.5 57v43h55V57z",
    fill: "#FFD89D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.707 46.491A12.002 12.002 0 0 1 33.5 45h31c2.044 0 4.035.522 5.793 1.491C68.917 48.468 68.5 52.212 68.5 56.5c0 6.347.913 12.5 4.5 12.5 1.288 0 2.489-.149 3.5-.633V100h-55V68.367c1.011.484 2.212.633 3.5.633 3.587 0 4.5-6.153 4.5-12.5 0-4.288-.417-8.032-1.793-10.009z",
    fill: "#CC9543"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFD89D",
    cx: 49,
    cy: 30,
    r: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5 34v-1.5a2.5 2.5 0 1 1 5 0V34M36.5 34v-1.5a2.5 2.5 0 1 1 5 0V34",
    stroke: "#4A4A4A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5 41h-9v.002A3.998 3.998 0 0 0 48.498 45H49.5a4 4 0 0 0 4-4z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 35.5a1.503 1.503 0 0 1-1.5 1.5H28a1.503 1.503 0 0 1-1.5-1.5V20a20 20 0 0 1 20-20h5a20 20 0 0 1 20 20v15.5A1.503 1.503 0 0 1 70 37h-3.5a1.503 1.503 0 0 1-1.5-1.5v-4.936A6.564 6.564 0 0 0 58.436 24h-.002A6.435 6.435 0 0 0 52 30.434V36.5a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-5.936A6.564 6.564 0 0 0 39.436 24h-.002A6.435 6.435 0 0 0 33 30.434V35.5z",
    fill: "#8E8E4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.98 47.378l.52 3.122c-5.9 0-11.066-3.959-12.6-9.656l-3.1-11.516a6.524 6.524 0 0 0-6.3-4.828v-5h5.001a15.476 15.476 0 0 1 13.545 11l1.207 3.845A43.803 43.803 0 0 0 98 47.5h-3.766c-.425 0-.845-.042-1.254-.122zM5.02 47.378L4.5 50.5c5.9 0 11.066-3.959 12.6-9.656l3.1-11.516a6.524 6.524 0 0 1 6.3-4.828v-5h-5.001a15.476 15.476 0 0 0-13.545 11l-1.207 3.845A43.803 43.803 0 0 1 0 47.5h3.766c.425 0 .845-.042 1.254-.122z",
    fill: "#EC761F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirls);
export default __webpack_public_path__ + "static/media/girls.489f15f70a52f5f2c99537a24cef57ad.svg";
export { ForwardRef as ReactComponent };